<button class="fulfillment-button fulfillment-options-container hmf-justify-content-left hmf-sharp-radius hmf-p-xxs hmf-p-m-s dynamic-fill"
        [ngClass]="{ selected: isSelected, disabled: isDisabled }">

    <ng-content select=".fulfillment-icon"></ng-content>

    <span class="fulfillment-type-label hmf-mt-m-xxxs hmf-header-bold-xs hmf-body-bold-m-l hmf-ml-0 hmf-header-bold-m-s">
        <ng-content select="[fulfillment-type-label]"></ng-content>
    </span>
    <span class="fulfillment-text fulfillment-options-description hmf-subheader-s hmf-subheader-m-m">
        <ng-content select="[fulfillmentText]"></ng-content>
    </span>
    <span class="fulfillment-subtext fulfillment-options-description hmf-subheader-s hmf-subheader-m-m">
        <ng-content select="span.fulfillmentSubText[text]"></ng-content>
    </span>
    <span class="fulfillment-subtext-link fulfillment-options-description hmf-subheader-s hmf-subheader-m-m">
        <ng-content select="span.fulfillmentSubText[link]"></ng-content>
    </span>
</button>
